// extracted by mini-css-extract-plugin
module.exports = {"result":"NumericResultBase_result_34gPc","value":"NumericResultBase_value_1hk-y","error":"NumericResultBase_error_38hf4"};